<template>
  <transition v-if="fade" name="fade">
    <div :class="classes" :style="wraperStyles" @click.stop="check">
      <!-- <span :class="dotClasses" v-if="showDot" :style="bgColorStyle"></span> -->
      <i v-if="showDot" :class="taggIconClass" :style="bgColorStyle" />
      <span :class="textClasses" :style="textColorStyle"><slot /></span>
      <i v-if="closable" class="far fa-times-circle i-close" :color="lineColor" @click="close" />
      <!-- <Icon v-if="closable" :class="iconClass" :color="lineColor" type="ios-close" @click.native.stop="close" /> -->
    </div>
  </transition>
  <div v-else :class="classes" :style="wraperStyles" @click.stop="check">
    <!-- <span :class="dotClasses" v-if="showDot" :style="bgColorStyle"></span> -->
    <i v-if="showDot" :class="taggIconClass" :style="bgColorStyle" />
    <span :class="textClasses" :style="textColorStyle"><slot /></span>
    <Icon v-if="closable" :class="iconClass" :color="lineColor" type="ios-close" @click.native.stop="close" />
    <!-- <i class="far fa-times-circle i-close" v-if="closable" :color="lineColor" @click.native.stop="close"></i> -->
  </div>
</template>
<script>
import { oneOf } from '@/utils/util'
const prefixCls = 'ivu-tag'
const initColorList = ['default', 'primary', 'success', 'warning', 'error', 'blue', 'green', 'red', 'yellow', 'pink', 'magenta', 'volcano', 'orange', 'gold', 'lime', 'cyan', 'geekblue', 'purple']
const colorList = ['pink', 'magenta', 'volcano', 'orange', 'gold', 'lime', 'cyan', 'geekblue', 'purple']

export default {
  name: 'IconicTag',
  props: {
    closable: {
      type: Boolean,
      default: false
    },
    checkable: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'default'
    },
    meta: {
      type: Object,
      default: null
    },
    type: {
      validator(value) {
        return oneOf(value, ['border', 'dot'])
      }
    },
    name: {
      type: [String, Number]
    },
    fade: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isChecked: this.checked
    }
  },
  computed: {
    taggIconClass() {
      return [
        'i-dot',
        'fa',
        this.meta && this.meta.icon ? this.meta.icon : 'fa-circle'
      ]
    },
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-${this.color}`]: !!this.color && oneOf(this.color, initColorList),
          [`${prefixCls}-${this.type}`]: !!this.type,
          [`${prefixCls}-closable`]: this.closable,
          [`${prefixCls}-checked`]: this.isChecked
        }
      ]
    },
    wraperStyles() {
      return oneOf(this.color, initColorList) ? {} : { background: this.isChecked ? this.defaultTypeColor : 'transparent', borderWidth: '1px', borderStyle: 'solid', borderColor: ((this.type !== 'dot' && this.type !== 'border' && this.isChecked) ? this.borderColor : this.lineColor), color: this.lineColor }
    },
    textClasses() {
      return [
        `${prefixCls}-text`,
        this.type === 'border' ? (oneOf(this.color, initColorList) ? `${prefixCls}-color-${this.color}` : '') : '',
        (this.type !== 'dot' && this.type !== 'border' && this.color !== 'default') ? (this.isChecked && colorList.indexOf(this.color) < 0 ? `${prefixCls}-color-white` : '') : ''
      ]
    },
    dotClasses() {
      return `${prefixCls}-dot-inner`
    },
    iconClass() {
      if (this.type === 'dot') {
        return ''
      } else if (this.type === 'border') {
        return oneOf(this.color, initColorList) ? `${prefixCls}-color-${this.color}` : ''
      } else {
        return this.color !== undefined ? (this.color === 'default' ? '' : 'rgb(255, 255, 255)') : ''
      }
    },
    showDot() {
      return !!this.type && this.type === 'dot'
    },
    lineColor() {
      if (this.type === 'dot') {
        return ''
      } else if (this.type === 'border') {
        return this.color !== undefined ? (oneOf(this.color, initColorList) ? '' : this.color) : ''
      } else {
        return this.color !== undefined ? (this.color === 'default' ? '' : 'rgb(255, 255, 255)') : ''
      }
    },
    borderColor() {
      return this.color !== undefined ? (this.color === 'default' ? '' : this.color) : ''
    },
    dotColor() {
      return this.color !== undefined ? (oneOf(this.color, initColorList) ? '' : this.color) : ''
    },
    textColorStyle() {
      return oneOf(this.color, initColorList) ? {} : ((this.type !== 'dot' && this.type !== 'border') ? (this.isChecked ? { color: this.lineColor } : {}) : { color: this.lineColor })
    },
    bgColorStyle() {
      return oneOf(this.color, initColorList) ? {} : { background: this.dotColor }
    },
    defaultTypeColor() {
      return (this.type !== 'dot' && this.type !== 'border') ? (this.color !== undefined ? (oneOf(this.color, initColorList) ? '' : this.color) : '') : ''
    }
  },
  watch: {
    checked(val) {
      this.isChecked = val
    }
  },
  methods: {
    close(event) {
      if (this.name === undefined) {
        this.$emit('on-close', event)
      } else {
        this.$emit('on-close', event, this.name)
      }
    },
    check() {
      if (!this.checkable) return
      const checked = !this.isChecked
      this.isChecked = checked
      if (this.name === undefined) {
        this.$emit('on-change', checked)
      } else {
        this.$emit('on-change', checked, this.name)
      }
    }
  }
}
</script>
